import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { PageLayout } from 'components/PageLayout';
import { CriticalAlertsPermissionContent } from './CriticalAlertsPermissionContent';

export const CriticalAlertsPermission = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <PageLayout
      data-cname="CriticalAlertsPermissionPage"
      data-testid="criticalAlertsPermissionPage"
    >
      <Helmet>
        <title>{t('criticalAlertPermission.title')}</title>
      </Helmet>
      <CriticalAlertsPermissionContent />
    </PageLayout>
  );
};
